// extracted by mini-css-extract-plugin
export default {"homeContent__top":"c-i_cp","homeContent__bottom":"c-i_cq","homeContent__cardHolder":"c-i_cr","homeContent__seoTextHolder":"c-i_cs"};